import React from 'react';
import {Navigate, useSearchParams} from 'react-router-dom';
import {LocalStorage} from '../../utils/LocalStorage';

/**
 * Componente que recibe datos de autenticacion desde mcp.ai.dashbo.io
 * y los guarda en LocalStorage para que el usuario quede logueado.
 * Redirige a /dashbo-mcp o a /login si faltan params.
 */
export function AuthFromMCP() {
    const [searchParams] = useSearchParams();

    const token = searchParams.get('token');
    const userId = searchParams.get('user_id');
    const userType = searchParams.get('user_type');
    const agencyStatus = searchParams.get('agency_status') || 'Active';
    const language = searchParams.get('language') || 'es';

    if (!token || !userId || !userType) {
        return <Navigate to="/login" replace/>;
    }

    LocalStorage.saveUserData(userId, token, userType, agencyStatus, language, null, true);

    return <Navigate to="/dashbo-mcp" replace/>;
}
